import FileUploadImageErrorModal from "./FileUploadImageErrorModal";

export default FileUploadImageErrorModal;
